<template>
	<div class="ai_container">
		<Toast :isVisible="isaVisible" :title="`AI 견적 서비스를 이용하려면\n동의가 필요해요`">
			<div class="all_check_wrapper">
				<CheckBox :onClick="handleAllCheck" :value="isAllChecked" :text="'약관 전체동의'" />
			</div>
			<ul class="signup_term_list">
				<li v-for="(item, index) in items" :key="index">
					<CheckBox :onClick="value => handleCheck(value, index)" :value="item.isChecked">
						<p class="body_8">
							<b>{{ item.required ? "[필수]" : "[선택]" }}</b>
							<span>{{ item.title }}</span>
						</p>
					</CheckBox>
					<img src="/static/icons/arrow/arrow_small_bold_right.svg"
						@click="() => handleTermModalOpen(index)" />
				</li>
			</ul>
			<!-- <Tooltip :text="'마케팅 활용 동의 시 0,000원 쿠폰'" /> -->
			<Button :label="'가입하기'" :disabled="!isVerify" :onClick="handleSignup" style="marginTop: 32px" />
			<div class="close_button_wrapper">
				<button class="f_gray_3 button_3" @click="handleClose">
					닫기
				</button>
			</div>
		</Toast>

		<div class="login_container">
			<img src="/static/icons/close.svg" style="display: flex;margin-left:auto;" width="24" height="24" @click="prevAiHome" />

			<div class="top_wrapper">
				<img src="/static/images/ai/ai_logo.png" width="170" alt="huckleberry" />
				<div>
					<p class="heading_10 f_gray_5">회원가입이 필요해요</p>
					<h1 class="heading_5">
						TMAP 특가 혜택도 받고 <br />
						AI 견적도 확인하고!
					</h1>
				</div>
				<!-- <Tooltip :text="'정비 할인쿠폰은 덤으로 챙기세요!'" /> -->
			</div>
			<div class="bottom_wrapper">
				<button class="social_button f_gray_12 button_2" style="backgroundColor: #03CF5D" @click="startingWithSocial('N')">
					<img src="/static/icons/naver.svg" />
					<p>네이버로 시작하기</p>
				</button>
				<button class="social_button button_2" style="backgroundColor: #FEE500" @click="startingWithSocial('K')">
					<img src="/static/icons/kakao.svg" />
					<p>카카오로 시작하기</p>
				</button>
			</div>
			<Modal
				v-if="!!termItem"
				:isVisible="!!termItem"
				:title="termItem.title"
				:onClose="handleTermModalClose"
				:hasPadding="true"
				:content="termItem.content">
			</Modal>

		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import Utils from '@/modules/utils'
import store from '@/stores'
import Toast from '../../components/ai/AiToast.vue'
import CheckBox from '../../components/ai/AiCheckBox.vue'
import Button from '../../components/ai/AiButton.vue'
import Modal from '../../components/ai/AiModal.vue'
import Tooltip from '../../components/ai/AiTooltip.vue'
//import VueCookies from 'vue-cookies'
import { EventBus } from "@/modules/event-bus"
import Header from '../../components/ai/AiHeader.vue'


export default {
	name: 'AiLogin',
	components: {
		Toast,
		CheckBox,
		Button,
		Modal,
		Tooltip,
		Header,
	},
	computed:{
	},
	data() {
		return {
			redirectname:this.$route.params.redirectname,
			redirectSeq:this.$route.params.estimateSeq,
			redirectparams:{

			},
			termItem:undefined,
			isSignupButtonDisable: true,
			isaVisible: false,
			isVerify: false,
			isAllChecked: false,
			items: [],
			channel:'',
			socialUserChk:'',
			userNo:'',
			ci:'',
			name:'',
			gender:'',
			birthday:'',
			birthyear:'',
			mobile:'',
			joinChannel:'',
			params: {
			ci:'',
			name:'',
			gender:'',
			birthday:'',
			birthyear:'',
			mobile:'',
			joinChannel:'',
			socialUserChk:'',
			decriptName:'',
			decriptBirthday:'',
			decriptMobile:'',
			channel:'',
			termList: [{}],
			},
		}
	},

	methods: {
		prevAiHome() {
			this.$router.push({ name: 'AiMain' })
		},
		handlePrev() {
		},
		startingWithSocial(socialGb) {
			this.channel = socialGb
			//토스트 노출여부
			//this.isaVisible = true;

			Vue.$sessionStorage.set('socialSelectYn', this.channel);

			if(this.channel == "N"){
				window.location.href = "https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id="+ AppConfig.NAVER_CLIENT_ID +"&redirect_uri="+process.env.SERVER_AUTH_URL+"/m/ai/login/oauth2/code/naver";
			}else{
				window.location.href = "https://kauth.kakao.com/oauth/authorize?client_id="+ AppConfig.KAKAO_CLIENT_ID +"&redirect_uri="+process.env.SERVER_AUTH_URL+"/m/ai/login/oauth2/code/kakao&response_type=code";
			}


		},
		handleSignup() {

			//회원정보
			this.params.ci = this.ci;
			this.params.name = this.name;
			this.params.gender = this.gender;
			this.params.birthday = this.birthday;
			this.params.birthyear = this.birthyear;
			this.params.mobile = this.mobile;
			this.params.joinChannel = this.joinChannel;
			this.params.socialUserChk = this.socialUserChk;
			this.params.channel = Vue.$sessionStorage.get('aiChannel');

			//여러번 클릭방지
			this.isVerify = false;

			//약관동의
			this.params.termList = this.items;

			Vue.httpClient
			.post(AppConfig.HTTP_CONFIG.authURL + '/m/ai/login/socialUserSave', this.params)
			.then(response => {
			if (response.data.result) {
				Vue.httpClient.defaults.headers.common['x-auth-token'] = response.headers['x-auth-token'];
				Vue.$sessionStorage.set('xAuthToken', response.headers['x-auth-token'])

				Vue.$sessionStorage.set('userNo', response.data.result.userNo);
				Vue.$sessionStorage.set('ci', this.ci);
				Vue.$sessionStorage.set('joinChannel', this.joinChannel);
				Vue.$sessionStorage.set('gender', this.gender);
				Vue.$sessionStorage.set('decriptName', this.decriptName);
				Vue.$sessionStorage.set('decriptBirthday', this.decriptBirthday);
				Vue.$sessionStorage.set('decriptMobile', this.decriptMobile);

				Vue.$sessionStorage.set('isLogin', true);
				EventBus.$emit('is-new-login')

				var redirectname1 = Vue.$sessionStorage.get('redirectname');
				if(!redirectname1){
					redirectname1 = 'AiMain'
				}
				this.$router.push({ name: redirectname1,params:this.redirectparams})
				this.isVerify = true;
			}
			})

			EventBus.$emit("ai-event-reaction");
		},
		handleClose() {
			this.isaVisible = false;
		},
		handleAllCheck(value) {
			this.isAllChecked = value
			this.isVerify = value
			this.items.forEach(v => {
				v.isChecked = value

			})
		},

		handleTermModalClose() {
			this.termItem = undefined
		},
		handleTermModalOpen(index) {
			this.termItem = this.items[index]
		},
		handleCheck(value, index) {
			this.items[index].isChecked = value
			this.isVerify = this.items
				.filter(({ required }) => required)
				.every(({ isChecked }) => isChecked)
			this.isAllChecked = this.items.every(({ isChecked }) => isChecked)
		},

		async getTermsList(){
			var $this = this;
			Vue.httpClient
			.post('/m/ai/term/list', {termType:10})
			.then(response => {
				if(response.data.status=='200'){
					var result = response.data.result

					result.forEach((item)=>{
						let pushitem={}
						pushitem.title = item.title
						pushitem.content = item.contents
						pushitem.termSeq = item.termSeq
						if(item.requiredYn==='Y'){
							pushitem.required = true
							pushitem.isChecked = true
						} else {
							pushitem.required = false
							pushitem.isChecked = false
						}
						$this.items.push(pushitem)
					})
					$this.isaVisible = true;
					$this.isVerify = true;
				}
			})

		}
	},
	mounted() {
		//간편로그인에 실패하였습니다. (개인정보 미제공)
		if(this.$cookies.get("errorCode") == "E01"){
			alert("간편로그인에 실패하였습니다. (개인정보 미제공)");
			//this.$cookies.remove("errorCode")
			this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie));
			return;
		}else if(this.$cookies.get("errorCode") == "E02"){
			alert("탈퇴후 30일 이내에 동일 명의로\n가입이 불가능합니다. \n(탈퇴일자 : "+this.$cookies.get("aiUserWithdrawDt")+")");
			this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie));
			return;
		}else if(this.$cookies.get("errorCode") == "E03"){
			alert("간편로그인 처리중 오류가 발생하였습니다.\n잠시후 다시 시도해 주시기 바랍니다.");
			this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie));
			return;
		}


		const seq = this.$route.params.estimateSeq;
		if(seq){
			this.redirectname = 'AiConfirm'
			Vue.$sessionStorage.set('redirectseq', seq);
			Vue.$sessionStorage.set('redirectname', 'AiConfirm');
		}

		if(Vue.$sessionStorage.get('redirectseq')){
			this.redirectparams.aiseq = Vue.$sessionStorage.get('redirectseq')
		}

		//Vue.use(VueCookies);
		this.oAuthLoginType = this.$cookies.get("oAuthLoginType");
		this.socialUserChk = this.$cookies.get("socialUserChk");
		this.userNo = this.$cookies.get("userNo");
		this.ci = this.$cookies.get("ci");
		this.name = this.$cookies.get("name");
		this.gender = this.$cookies.get("gender");
		this.birthday = this.$cookies.get("birthday");
		this.birthyear = this.$cookies.get("birthyear");
		this.mobile = this.$cookies.get("mobile");
		this.joinChannel = this.$cookies.get("joinChannel");

		this.decriptName = this.$cookies.get("decriptName");
		this.decriptBirthday = this.$cookies.get("decriptBirthday");
		this.decriptMobile = this.$cookies.get("decriptMobile");

		if(!Utils.isEmpty(this.redirectname)){
			Vue.$sessionStorage.set('redirectname', this.redirectname);
		}

		const aa = Vue.$sessionStorage.get('socialSelectYn');

		if(this.$cookies.get("jwt") != '' && this.$cookies.get("jwt") != null){
			const cookie1 = this.$cookies.get("jwt");
			const cookie2 = this.$cookies.get("oAuthLoginType");

			Vue.httpClient.defaults.headers.common['x-auth-token'] = cookie1;
			//Vue.httpClient.defaults.headers.common['oAuthLoginType'] = cookie2;

			window.$store.commit('Login/setToken', { token: cookie1 })
			window.$store.commit('Login/setUserNo', { userNo: this.$cookies.get("userNo") })

			//alert(window.$store.getters['Login/getToken']);

			Vue.$sessionStorage.set('xAuthToken', cookie1);
			Vue.$sessionStorage.set('oAuthLoginType', cookie2);
			Vue.$sessionStorage.set('userNo', this.$cookies.get("userNo"));
			Vue.$sessionStorage.set('ci', this.$cookies.get("ci"));
			Vue.$sessionStorage.set('name', this.$cookies.get("name"));
			Vue.$sessionStorage.set('gender', this.$cookies.get("gender"));
			Vue.$sessionStorage.set('birthday', this.$cookies.get("birthday"));
			Vue.$sessionStorage.set('birthyear', this.$cookies.get("birthyear"));
			Vue.$sessionStorage.set('mobile', this.$cookies.get("mobile"));
			Vue.$sessionStorage.set('joinChannel', this.$cookies.get("joinChannel"));
			Vue.$sessionStorage.set('decriptName', this.$cookies.get("decriptName"));
			Vue.$sessionStorage.set('decriptBirthday', this.$cookies.get("decriptBirthday"));
			Vue.$sessionStorage.set('decriptMobile', this.$cookies.get("decriptMobile"));
			Vue.$sessionStorage.set('isLogin', true);

			var redirectname1 = Vue.$sessionStorage.get('redirectname');
			if(!redirectname1){
				redirectname1 = 'AiMain'
			}

			//사용후 쿠키 제거(도메인 추가)
			this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie,'',AppConfig.COOKIE_DOMAIN));

			EventBus.$emit("ai-event-reaction");
			this.$router.push({ name: redirectname1,params:this.redirectparams})
		}

		//토스트 노출여부
		if(aa != "" && this.socialUserChk == "false"){
			this.getTermsList();
		}

		Vue.$sessionStorage.set('socialSelectYn', '');

	},
}
</script>


// WEBPACK FOOTER //
// src/views/ai/AiLogin.vue